module.exports = __webpack_public_path__ + "df6b0cd18fa68eef98b801dc3acb6ccc.cur";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/cur/circle-80.cur
// module id = 479
// module chunks = 0